import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = '/api';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const nav = useNavigate();

  const login = async () => {
    if (!form.username || !form.password) { setError('Completá usuario y contraseña'); return; }
    setCargando(true);
    try {
      const r = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem('ep_usuario', JSON.stringify(r.data.usuario));
      nav('/admin');
    } catch (e) {
      setError(e.response?.data?.error || 'Error al iniciar sesión');
    }
    setCargando(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #5fa8a0, #3d8a82)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: 32, width: '100%', maxWidth: 360, boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }}>
        
        {/* LOGO */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 48 }}>🕌</div>
          <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: 2, color: '#3d8a82' }}>essence pure</div>
          <div style={{ fontSize: 12, color: '#aaa', letterSpacing: 1 }}>panel de administración</div>
        </div>

        {/* FORM */}
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Usuario</label>
          <input
            style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8c97a', fontSize: 14, boxSizing: 'border-box', background: '#fffdf7' }}
            placeholder="Ingresa tu usuario"
            value={form.username}
            onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && login()}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Contraseña</label>
          <input
            type="password"
            style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8c97a', fontSize: 14, boxSizing: 'border-box', background: '#fffdf7' }}
            placeholder="••••••••"
            value={form.password}
            onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && login()}
          />
        </div>

        {error && (
          <div style={{ background: '#fce4ec', color: '#c62828', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginBottom: 14, textAlign: 'center' }}>
            {error}
          </div>
        )}

        <button
          onClick={login}
          disabled={cargando}
          style={{ width: '100%', padding: '12px', borderRadius: 10, border: 'none', background: '#b8860b', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>
          {cargando ? 'Ingresando...' : 'Ingresar 🔑'}
        </button>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <a href="/" style={{ fontSize: 12, color: '#5fa8a0', textDecoration: 'none' }}>← Volver al catálogo</a>
        </div>
      </div>
    </div>
  );
}